<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText2"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText2: '',
    };
  },
  mounted () {
    this.richText2 = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Spectrometry & Spectroscopy Unit</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:75%; height:100%;">'
      + '<p style="margin-right : 20px;text-align: justify;line-height: 230%"><span style="font-size: 16px">Spectrometry & Spectroscopy Unit comprises five labs, namely Molecular Spectroscopy Lab, Nuclear Magnetic Resonance Spectroscopy Lab, Liquid Chromatography & Mass Spectrometry Lab, Gas Chromatography & Stable Isotope Ratio Mass Spectrometry Lab, and Proteomics & Gene Sequencing'
      + ' Lab. We provide access to cutting-edge instrumentation and expert assistance for organic molecular and macromolecular characterization, quantification, sample preparation, intermolecular interaction analysis, conformation analysis and high throughput gene sequencing. Our unit brings together 55 sets of advanced equipment and expertise to support chemical, biological, medical,'
      + ' pharmaceutical, material and environmental researches. A group of 23 lab technicians provides extensive services in sample preparation, method development, data analysis and technique training.</span></p>'
      + '</div>'

      + '<div id="right" style="float:left ; width:25%; height:100%;">'
      + '<p style="margin-left : 40px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/leifeng.jpg" style="float: left; width: 200px; margin-right: 30px; margin-top:20px;" border="0" vspace="0" alt=""></p>'
      + '<p style="margin-left:50px;text-align: justify"><span style="font-size: 16px;"><b>Director: Lei Feng</b></span></p>'
      + '</div>'

      + '<div>'
      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> Molecular Spectroscopy Lab </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment： Fluorescence Spectrometer, Raman Microscope, FTIR, CD, VCD</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services： structural elucidation, optical performance analysis, material performance analysis, component failure analysis</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> Nuclear Magnetic Resonance Spectroscopy</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment： liquid NMR, solid state NMR, low field NMR</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: structural elucidation, kinetics, diffusion NMR, low field nuclear magnetic resonance \n' +
      'imaging</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> Chromatography & Mass Spectrometry Lab </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：GCMS, LCMS, stable isotope ratio MS, imaging MS, preparative chromatography</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: structural elucidation, qualitative & quantitative analysis, MS imaging, metabolomics, sample preparation</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;Proteomics & Gene Sequencing Lab&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：NanoLCMS, BIACORE surface plasmon resonance, microplate reader, Sequel gene sequencing.</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: qualitative & quantitative proteomics, intermolecular interaction analysis, high throughput gene sequencing.</span></p>'

      + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/spectrometry_spectroscopy_en_1.jpg" style="float: left; width: 800px; " border="0" vspace="0" ></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Lei Feng</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: fiona.fenglei@sjtu.edu.cn</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Tel: +86-021-34208498-6415</span></p>'

      + '</div>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service16/en/index.vue